import { useEffect, useState, useMemo } from "react";
import { ToastContainer } from "@cisco/spaces-dash-lib-notification";
import { I18nContext } from "./contexts/i18nContext";
import { LoginPage } from "./page/login-page";
import { SupportLoginPage } from "./page/support-login-page";
import { getDashboardProperties } from "./services/partner-login-service";
import { PropertiesContext } from "./contexts/propertiesContext";
import type { RootProps } from "./types/components";
import type { DashboardProperties } from "./types";

export default function Root(props: RootProps) {
  const {
    appData: { i18n }
  } = props;
  const [isSupport, setIsSupport] = useState<boolean>(false);
  const [properties, setProperties] = useState<DashboardProperties | null>(null);
  const [i18nLoaded, setI18nLoaded] = useState<boolean>(false);
  const contextValue = useMemo(() => ({ properties, setProperties }), [properties]);

  useEffect(() => {
    i18n.loadNamespaces("spaces-dash-app-partners-login", () => {
      setI18nLoaded(true);
    });
  }, [i18n]);

  const fetchDashboardProperties = async (): Promise<void> => {
    try {
      const res = await getDashboardProperties();

      if (res.status && res.data) {
        setProperties(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDashboardProperties();
  }, []);

  useEffect(() => {
    if (window.location.pathname.indexOf("/manage/support/login") > -1) {
      setIsSupport(true);
    }
  }, []);

  return (
    <I18nContext.Provider value={i18n}>
      <ToastContainer autoCloseTimeout={0.1} />
      {i18nLoaded && <PropertiesContext.Provider value={contextValue}>{isSupport ? <SupportLoginPage /> : <LoginPage />}</PropertiesContext.Provider>}
    </I18nContext.Provider>
  );
}
